// JS for block-specific behavior only
console.log('initial block block loaded');